import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Tracks which quote ids the current viewer (client) has already opened, so
 * the sidebar can show a "new quotes" badge for ones never visited.
 * Local-only: avoids extra RLS surface area on the quotes table.
 */
type State = {
  seen: string[];
  markSeen: (id: string) => void;
  isSeen: (id: string) => boolean;
};

export const useClientSeenQuotes = create<State>()(
  persist(
    (set, get) => ({
      seen: [],
      markSeen: (id) =>
        set((s) => (s.seen.includes(id) ? s : { seen: [...s.seen, id] })),
      isSeen: (id) => get().seen.includes(id),
    }),
    { name: "sc-client-seen-quotes" },
  ),
);